// No direct PHP counterpart.
// JS discovery index for the sibling PHP unit files in this directory tree.
// Auto-discovers all post rule classes in this directory.
// Mirrors PHP's Helpers::classes() pattern.

var requireRule = require.context('.', false, /\.js$/)
var rules = []

requireRule.keys().forEach(function(filename) {
	if (filename === './index.js') return

	var mod = requireRule(filename)
	var rule = mod.default || mod

	if (rule && typeof rule.require === 'function' && typeof rule.run === 'function') {
		rules.push(rule)
	}
})

rules.sort(function(a, b) {
	return a.priority() - b.priority()
})

export function postRules() {
	return rules
}
